const MESSAGE =
  "WC x THE SYSTEM — MAY 31, 2026 — DOMESTIC VOL. 1 — GUATEMALA DROP — JULY 2026 — NO GUARANTEED RESTOCK — IF YOU MISS IT YOU MISS IT — WRONG CONCEPTION — QUESTION EVERYTHING — INTERNATIONAL DROPS — DOMESTIC DROPS — JOIN THE WAITLIST — LINK IN BIO — WRONG CONCEPTION — ";

export const AnnouncementBar = () => {
  return (
    <div
      className="bg-black border-b border-white text-white py-2 overflow-hidden whitespace-nowrap select-none"
      data-testid="announcement-bar"
    >
      <div className="wc-marquee wc-label text-[10px] md:text-xs">
        <span className="pr-12">{MESSAGE.repeat(4)}</span>
        <span className="pr-12" aria-hidden="true">
          {MESSAGE.repeat(4)}
        </span>
      </div>
    </div>
  );
};

export default AnnouncementBar;
